import sliderModule from './swiper/sliders.js';
import interview    from './swiper/interview.js';

const {
    sliders,
    slidersResize,
    sliderHomes

} = sliderModule;

// Init
function init() {
    const sliderHome = document.querySelectorAll('[data-slider="home"]');
    sliderHome.forEach((el) => {
        sliderHomes(el, {
            slidesPerView : 1,
            mousewheel    : true,
            direction     : 'vertical',
            speed         : 800,
            effect        : 'fade',
            fadeEffect    : { crossFade : true }
        });
    });

    const interviewSlider = [...document.querySelectorAll('[data-interview="wrapper"]')];
    interviewSlider.forEach((item) => interview(item, {
        slidesPerView : 'auto',
        navigation    : {
            nextEl : '.interview-slide-next',
            prevEl : '.interview-slide-prev'
        }
    }));
    const sliderResize = document.querySelectorAll('[data-slider="resize"]');
    sliderResize.forEach((el) => {
        slidersResize(el, {
            breakpoint : 681
        });
    });
}

(function () {
    init();
}());
